import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import AuthenticatedRouter from '@views/AuthenticatedRouter';
import UnauthenticatedRouter from '@views/UnauthenticatedRouter';

// Compatibility wrapper for class components that need router props (replaces withRouter from v4/v5)
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  }
  return ComponentWithRouterProp;
}

class BaseLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const Component = (this.props.is_authenticated) ? AuthenticatedRouter : UnauthenticatedRouter;
    return <Component location={this.props.location} />
  }
}

const mapStateToProps = (state) => {
  return {
    is_authenticated: state.usersReducer.is_authenticated,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BaseLayout));
